import { format } from 'date-fns';
/** Convertit un Date en string YYYY-MM-DD timezone-safe (utilise le fuseau local) */
export function toDateOnlyString(date) {
    return format(date, 'yyyy-MM-dd');
}
